import { User } from "./user";

export class UserLogout {
    constructor(
        public user: User,
        public triggeredByUser: boolean) {
    }
}
